<template>
  <div>
    <v-row>
      <h1 class="ml-4">Legal</h1>
    </v-row>
    <v-row class="mt-2 reduce-zoom">
      <!-- <v-col>
        <total-referrals-statistics-card />
      </v-col> -->
      <v-col> </v-col>
    </v-row>
    <v-spacer></v-spacer>
    <v-card class="mt-3">
      <v-card-title>
        <v-autocomplete
          v-model="search"
          :items="referrals.records"
          item-text="name"
          append-icon="mdi-magnify"
          :loading="isLoading"
          :disabled="isLoading"
          small-chips
          label="Type an lead sources name to search..."
          outlined
          clearable
        >
        </v-autocomplete>
      </v-card-title>
      <v-card-text>
        {{ legal }}
        <v-data-table
          :headers="headers"
          :items="legal"
          :loading="isLoading"
          :search="search"
          transition="scale-transition"
          class="new-detault-table lead-view"
        >
          <template v-slot:top>
            <v-spacer /> <v-spacer /> <v-spacer />
            <v-row class="card-slider mb-4" justify="center">
              <v-col cols="12" sm="4" md="4" lg="4">
                <v-btn
                  class="mr-4 text-right"
                  color="#feb809"
                  large
                  dark
                  @click="$router.push('/admin/legal/0/edit')"
                  ><h1>New lead source</h1></v-btn
                >
              </v-col>
              <!-- <v-col cols="12" sm="4" md="4" lg="4">
                 <download-excel
                  :data="referrals.records"
                  :fields="fields"
                  worksheet="LeadSources"
                  name="rebaseGroupCRMLeadSourcesList.xls"
                >
                  <v-btn color="#0a2752" large dark class="text-right">
                    <h1>Download</h1>
                  </v-btn>
                </download-excel>
              </v-col> -->
            </v-row>
          </template>
          <!-- <template v-slot:item.profilePicture="{ item }">
            <v-row justify="space-around">
              <v-avatar v-if="item.profilePicture" tile>
                <v-img
                  :src="item.profilePicture"
                  contain
                  alt="LeadSource"
                  color="teal"
                  size="120"
                />
              </v-avatar>
              <v-avatar v-else tile>
                <v-img
                  :src="defaultProfileImage()"
                  contain
                  alt="LeadSource"
                  color="teal"
                  size="120"
                />
              </v-avatar>
            </v-row>
          </template>
          <template v-slot:item.createdAt="{ item }">
            <h3 color="primary">{{ item.createdAt | getFormattedDate }}</h3>
          </template>
          <template v-slot:item.updatedAt="{ item }">
            <h3 color="primary">{{ item.updatedAt | getFormattedDate }}</h3>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn
              fab
              x-small
              dark
              class="mr-2"
              @click="editItem(item)"
              color="primary"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn
              fab
              x-small
              dark
              class="ml-2"
              @click="deleteItem(item)"
              color="error"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template> -->
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { gql } from "apollo-boost";
import defaultProfile from "../../../assets/img/avatar.png";

export default {
  components: { defaultProfile },
  data() {
    return {
      headers: [
        {
          text: "Icon",
          align: "center",
          sortable: false,
          value: "profilePicture",
        },
        {
          text: "Name",
          align: "start",
          sortable: false,
          value: "name",
        },
        { text: "Created Date", value: "createdAt" },
        { text: "Updated Date", value: "updatedAt" },
        { text: "Actions", align: "right", sortable: false, value: "actions" },
      ],
      search: "",
      referrals: [],
      totalRecords: 0,
      legal: [],
      isLoading: false,
      fields: {
        "Lead Source Name": "name",
      },
    };
  },
  apollo: {
    legalEntities: {
      query: gql`
        query LegalEntities(
          $limit: Int!
          $skip: Int!
          $query: JSON!
          $sort: JSON
        ) {
          legalEntities(
            limit: $limit
            skip: $skip
            query: $query
            sort: $sort
          ) {
            records {
              id
              name
              entityType
              registration
              hQName
              hqName_text
              industry
              industryName
              telephone
            }
            count
          }
        }
      `,
      fetchPolicy: "network-only",
      variables() {
        const self = this;
        const limit = 9999;
        const skip = 0;
        return {
          limit: limit,
          skip: skip,
          query: {},
        };
      },
      watchLoading(isLoading, countModifier) {
        this.isLoading = isLoading;
      },
      result({ data }, key) {
        this.legal = data.legalEntities.records;
      },
    },
  },
  methods: {
    editItem(item) {
      this.$router.push(`/admin/legal/${item.id}/edit`);
    },
    defaultProfileImage() {
      return defaultProfile;
    },
    deleteItem(item) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085D6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.value) {
          try {
            const response = await this.$apollo.mutate({
              mutation: gql`
                mutation ($id: ID!) {
                  deleteLegalEntity(id: $id) {
                    id
                    deleted
                  }
                }
              `,
              variables: {
                id: item.id,
              },
            });

            if (response) {
              this.$swal(
                "Success!",
                "Lead Source was successfully deleted",
                "success"
              );
              this.$router.go(this.$route.currentRoute);
            }
          } catch (e) {}
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
